import { numKeys } from "src/constants/KeyboardNumKeys";

export class ModalOptionBase {
    public id: number;
    public displayText: string;
    public object?: any;
}

export class PhaserModalConfigBase {
    public forceResponse?: boolean;
}

export class PhaserModalBase extends Phaser.GameObjects.Container {
    protected options: ModalOptionBase[];
    config: PhaserModalConfigBase;

    constructor(scene: Phaser.Scene, x: number, y: number, config?: PhaserModalConfigBase) {
        super(scene, x, y);
        this.config = config;
    }

    public selectOption(index: number): void {
        if (index >= this.options.length) {
            return;
        }

        let op: ModalOptionBase = this.options[index];
        this.emit('optionClicked', op);
        this.destroy();
    }

    public selectLastOption(): void {
        let op: ModalOptionBase = this.options[this.options.length - 1];
        this.emit('optionClicked', op);
        this.destroy();
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.scene.input.keyboard.on('keydown_' + key, event);
        });
    }

    bindNumKeys(): void {
        numKeys.forEach((key) => {
            this.onKeydown(() => { this.selectOption(key.index); }, key.keyCode, key.altKeyCode);
        });

        if (!this.config.forceResponse) {
            this.onKeydown(() => { this.destroy(); }, 'DELETE', 'BACKSPACE', 'ESC');
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PhaserModalBase.tsx